const {
  hasAcceptedCookies,
  cookieAcceptEventName,
} = require('@mondough/cookie-opt-in')

const facebookPixelScript = `
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');

  fbq('init', '1442053056123622');
  fbq('track', 'PageView');
`

exports.onClientEntry = () => {
  const facebookPixelInit = () => {
    const script = document.createElement('script')
    script.id = 'gatsby-plugin-facebook-pixel'
    const inlineScript = document.createTextNode(facebookPixelScript)
    script.appendChild(inlineScript)
    document.getElementsByTagName('head')[0].appendChild(script)
  }

  window.removeEventListener(cookieAcceptEventName, facebookPixelInit)
  window.addEventListener(cookieAcceptEventName, facebookPixelInit, {
    once: true,
  })

  if (hasAcceptedCookies('analytics')) facebookPixelInit()
}
